import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	loan: null,
	error: "",
	loading: false,
};

// ADD_overtime
export const addLoan = createAsyncThunk(
	"loan/addLoan",
	async (values, { rejectWithValue }) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `/loan`,
				data: {
					...values,
				},
			});

			// Assuming the backend returns the loan data in case of success
			toast.success("Loan added successfully!");
			return {
				data,
				message: "Loan added successfully!",  // Success message can be passed here
			};
		} catch (error) {
			console.error("Error adding loan:", error);
			toast.error(error.response?.data?.message || "Error in adding loan. Please try again.");
			return rejectWithValue(error.response?.data?.message || "An error occurred");
		}
	}
);

export const addEMI = createAsyncThunk(
	"loan/addLEMI",
	async (values, { rejectWithValue }) => {
		console.log("values", values);
		
		try {
			const { data } = await axios({
				method: "post",
				url: `/loan/Emi`,
				data: {
					...values,
				},
			});

			// Assuming the backend returns the loan data in case of success
			toast.success("Loan added successfully!");
			return {
				data,
				message: "Loan added successfully!",  // Success message can be passed here
			};
		} catch (error) {
			console.error("Error adding loan:", error);
			toast.error(error.response?.data?.message || "Error in adding loan. Please try again.");
			return rejectWithValue(error.response?.data?.message || "An error occurred");
		}
	}
);

// DELETE_overtime
export const deleteLoan = createAsyncThunk(
	"loan/deleteLoan ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `loan/${id}`,
			});

			toast.success("Loan deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting loan try again");
			console.log(error.message);
		}
	}
);


// loan
export const getAllLoan = createAsyncThunk(
	"loan/getAllLoan",
	async () => {
		try {
			const { data } = await axios.get(`loan`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const getSingleLoan = createAsyncThunk(
	"loan/getSingleLoan",
	async (id) => {
		try {
			const { data } = await axios.get(`loan/${id}`);

			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const getLoanByUser = createAsyncThunk(
	"loan/getLoanByUser",
	async (userId) => {
		try {
			const { data } = await axios.get(`loan/${userId}/user`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateLoan = createAsyncThunk(
	"loan/updateLoan",
	async ({ id, values }, { rejectWithValue }) => {
		try {
			const { data } = await axios({
				method: "put",
				url: `loan/${id}`,
				data: {
					...values,
				},
			});

			// Assuming backend returns the updated loan data on success
			toast.success("Loan updated successfully!");
			return {
				data,
				message: "Loan updated successfully!",
			};
		} catch (error) {
			console.error("Error updating loan:", error);
			// Displaying error message returned by backend (if available)
			toast.error(error.response?.data?.message || "Error in updating loan. Please try again.");
			return rejectWithValue(error.response?.data?.message || "An error occurred");
		}
	}
);

const loanSlice = createSlice({
	name: "loan",
	initialState,
	reducers: {
		clearOvertime: (state) => {
			state.loan = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllLoan ======

		builder.addCase(getAllLoan.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllLoan.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllLoan.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 1) ====== builders for getLoanByUser ======

		builder.addCase(getLoanByUser.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getLoanByUser.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getLoanByUser.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addLoan  ======

		builder.addCase(addLoan.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addLoan.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addLoan.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for addEMI  ======

		builder.addCase(addEMI.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addEMI.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addEMI.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});



		// 3) ====== builders for loan ======

		builder.addCase(updateLoan.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateLoan.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateLoan.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for getSingleLoan ======

		builder.addCase(getSingleLoan.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getSingleLoan.fulfilled, (state, action) => {
			state.loading = false;

			state.overtimeDetail = action.payload;
		});

		builder.addCase(getSingleLoan.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteLoan  ======

		builder.addCase(deleteLoan.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteLoan.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteLoan.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default loanSlice.reducer;
export const { clearOvertime } = loanSlice.actions;
